import React, { useEffect, useState } from "react";
import axios from 'axios';

const CurrentBids = ({ openEditDrawer, refreshTrigger }) => {
    const [bidsData, setBidsData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');

    const userType = localStorage.getItem("usertype"); 
    const loggedInUserId = localStorage.getItem("id") || localStorage.getItem("user_id");
    const loggedInFullName = (localStorage.getItem("fname") + " " + localStorage.getItem("lname")).trim();

    const fetchBids = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get('https://skcapi.btcjapan.co/get_current_bids.php', {
                headers: { Authorization: `Bearer ${token}` }
            });

            if (res.data.success) {
                let fetchedBids = res.data.data;
                if (userType === 'administrator') {
                    // Admin sees all
                } 
                else if (userType === 'leader') {
                    let leadersGroupId = null;
                    for (const bid of fetchedBids) {
                        if (bid.assigned_users && Array.isArray(bid.assigned_users)) {
                            const found = bid.assigned_users.find(u => String(u.id) === String(loggedInUserId));
                            if (found && bid.group_id) {
                                leadersGroupId = bid.group_id;
                                break; 
                            }
                        }
                    }
                    if (leadersGroupId) {
                        fetchedBids = fetchedBids.filter(bid => bid.group_id === leadersGroupId);
                    } else {
                        fetchedBids = []; 
                    }
                } 
                else if (userType === 'member') {
                    fetchedBids = fetchedBids.filter(bid => 
                        bid.assigned_users && Array.isArray(bid.assigned_users) && 
                        bid.assigned_users.some(u => String(u.id) === String(loggedInUserId))
                    );
                }
                setBidsData(fetchedBids);
            } else {
                setBidsData([]);
            }
        } catch (err) { 
            console.error(err); 
            setBidsData([]); 
        } finally { 
            setLoading(false); 
        }
    };

    useEffect(() => {
        fetchBids();
    }, [refreshTrigger]);

    // =============== DELETE FUNCTION ===============
    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this bid?")) return;
        try {
            const token = localStorage.getItem("token");
            const res = await axios.post(
                'https://skcapi.btcjapan.co/delete_bid.php',
                { id },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            if (res.data.success) {
                alert("Bid deleted successfully");
                fetchBids(); // Refresh the list
            } else {
                alert(res.data.error || "Delete failed");
            }
        } catch (err) {
            alert("Error deleting bid");
            console.error(err);
        }
    };    

    const filteredBids = bidsData.filter(bid => {
        const term = searchTerm.toLowerCase();
        return (
            (bid.bid_region || "").toLowerCase().includes(term) ||
            (bid.bid_date || "").includes(term) ||
            (bid.bid_amount || "").toString().includes(term) ||
            (bid.vehicle_details || "").toLowerCase().includes(term) ||
            (bid.reporter || "").toLowerCase().includes(term)
        );
    });

    // Formatting Helpers
    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        const d = new Date(dateStr);
        return d.toLocaleDateString('en-GB');
    };

    const formatTime = (datetime) => {
        if (!datetime) return '';
        return new Date(datetime).toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const getAvatar = (user) => {
        if (user.image) {
            return (
                <img
                    src={user.image}
                    alt={user.name}
                    title={`${user.name} (${user.usertype})`}
                    style={{
                        width: 32, height: 32, borderRadius: '50%', objectFit: 'cover',
                        border: '2px solid #fff', boxShadow: '0 0 0 1px #ddd'
                    }}
                    onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextSibling.style.display = 'flex';
                    }}
                />
            );
        }
        return null;
    };

    const getInitialAvatar = (user) => {
        const colors = { administrator: '#dc3545', leader: '#007bff', manager: '#fd7e14', member: '#28a745' };
        return (
            <div
                title={`${user.name} (${user.usertype})`}
                style={{
                    width: 32, height: 32, borderRadius: '50%',
                    background: colors[user.usertype] || '#6c757d', color: '#fff',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontSize: 12, fontWeight: 600, border: '2px solid #fff',
                    boxShadow: '0 0 0 1px #ddd'
                }}
            >
                {user.name?.charAt(0).toUpperCase()}
            </div>
        );
    };

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                <div><span style={{ fontWeight: 'bold', fontSize: '12px' }}>Total Bids: {bidsData.length}</span></div>
                <div>
                    <input type="text" placeholder="Search all columns..." value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} style={{ padding: '7px 12px', border: '1px solid #ccc', borderRadius: 4, width: 220 }} />
                </div>
            </div>

            <div className="bids-table-wrapper" style={{ overflowX: 'auto', background: '#fff', borderRadius: 8 }}>
                <table className="bids-table" style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
                    <thead>
                        <tr style={{ background: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
                            <th style={{ padding: '12px 10px', textAlign: 'left' }}>ID</th>
                            <th style={{ padding: '12px 10px', textAlign: 'left' }}>Date & Time</th>
                            <th style={{ padding: '12px 10px', textAlign: 'left' }}>Bid Amount</th>
                            <th style={{ padding: '12px 10px', textAlign: 'left' }}>Region</th>
                            <th style={{ padding: '12px 10px', textAlign: 'left', minWidth: 280 }}>Vehicle Details</th>
                            <th style={{ padding: '12px 10px', textAlign: 'left' }}>Trans</th>
                            <th style={{ padding: '12px 10px', textAlign: 'left' }}>Drive</th>
                            <th style={{ padding: '12px 10px', textAlign: 'left' }}>Reverse</th>
                            <th style={{ padding: '12px 10px', textAlign: 'left' }}>Shipment</th>
                            <th style={{ padding: '12px 10px', textAlign: 'left' }}>Units</th>
                            <th style={{ padding: '12px 10px', textAlign: 'left' }}>Assigned To</th>
                            <th style={{ padding: '12px 10px', textAlign: 'center' }}>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {loading ? (
                            <tr><td colSpan="12" style={{ textAlign: 'center', padding: 60, color: '#6c757d' }}>Loading bids...</td></tr>
                        ) : filteredBids.length === 0 ? (
                            <tr><td colSpan="12" style={{ textAlign: 'center', padding: 60, color: '#6c757d' }}>No bids found.</td></tr>
                        ) : (
                            filteredBids.map((bid) => (
                                <tr key={bid.id} style={{ borderBottom: '1px solid #eee' }}>
                                    <td style={{ padding: '14px 10px', verticalAlign: 'top' }}>{bid.id}</td>
                                    <td style={{ padding: '14px 10px', verticalAlign: 'top' }}>
                                        <div style={{ fontWeight: 500 }}>{formatDate(bid.bid_date)}</div>
                                        <div style={{ fontSize: 11, color: '#888' }}>{formatTime(bid.created_at)}</div>
                                    </td>
                                    <td style={{ padding: '14px 10px', verticalAlign: 'top', fontWeight: 600 }}>
                                        {Number(bid.bid_amount).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                                    </td>
                                    <td style={{ padding: '14px 10px', verticalAlign: 'top' }}>{bid.bid_region}</td>
                                    <td style={{ padding: '14px 10px', verticalAlign: 'top', maxWidth: 320 }}>
                                        <div style={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
                                            {bid.vehicle_details?.split('\n').map((line, i) => (
                                                <div key={i} style={{ marginBottom: 2 }}>{line.startsWith('•') || line.startsWith('-') ? line : `• ${line}`}</div>
                                            ))}
                                        </div>
                                    </td>
                                    <td style={{ padding: '14px 10px', verticalAlign: 'top' }}>{bid.transmission}</td>
                                    <td style={{ padding: '14px 10px', verticalAlign: 'top' }}>{bid.drive_type}</td>
                                    <td style={{ padding: '14px 10px', verticalAlign: 'top' }}>{bid.reverse_option}</td>
                                    <td style={{ padding: '14px 10px', verticalAlign: 'top' }}>{bid.shipment_type}</td>
                                    <td style={{ padding: '14px 10px', verticalAlign: 'top' }}>{bid.required_units}</td>
                                    
                                    <td style={{ padding: '14px 10px', verticalAlign: 'top' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                            {bid.assigned_to_type === 'everyone' ? (
                                                <span style={{ background: '#6f42c1', color: '#fff', padding: '4px 10px', borderRadius: 20, fontSize: 12, fontWeight: 500 }}>Everyone</span>
                                            ) : (
                                                <>
                                                    {bid.assigned_users?.slice(0, 4).map((user, idx) => (
                                                        <div key={idx} style={{ position: 'relative' }}>
                                                            {getAvatar(user)}
                                                            <div style={{ display: user.image ? 'none' : 'flex' }}>{getInitialAvatar(user)}</div>
                                                        </div>
                                                    ))}
                                                </>
                                            )}
                                        </div>
                                    </td>

                                    <td style={{ padding: '14px 10px', verticalAlign: 'top', textAlign: 'center' }}>
                                        <div style={{ display: 'flex', gap: 6, justifyContent: 'center' }}>
                                            {/* === EDIT BUTTON === */}
                                            <button
                                                title="Edit"
                                                onClick={() => openEditDrawer && openEditDrawer(bid.id)}
                                                style={{
                                                    width: 32, height: 32, borderRadius: 4,
                                                    background: '#0d6efd', color: '#fff',
                                                    border: 'none', cursor: 'pointer', fontSize: 12
                                                }}
                                            >
                                                ✎
                                            </button>
                                            {/* === DELETE BUTTON === */}
                                            <button
                                                title="Delete"
                                                onClick={() => handleDelete(bid.id)}
                                                style={{
                                                    width: 32, height: 32, borderRadius: 4,
                                                    background: '#dc3545', color: '#fff',
                                                    border: 'none', cursor: 'pointer', fontSize: 12
                                                }}
                                            >
                                                🗑
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
export default CurrentBids;